<div class="pbe-card">

    <!-- Header -->
    <app-profile-section-header title="Domiciliaciones"
                                subtitle="Gestiona tus cuentas bancarias y la vinculación con tus pólizas">
        <svg headerIcon viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
            <rect x="2" y="6" width="20" height="12" rx="2"/>
            <line x1="2" y1="10" x2="22" y2="10"/>
        </svg>
    </app-profile-section-header>

    <!-- Datos bancarios -->
    <div class="pbe-section">
        <div class="pbe-section__heading">
            <h3 class="pbe-section__title">Datos bancarios</h3>
        </div>

        <div class="pbe-form">

            <div class="pbe-row pbe-row--policy-account" *ngFor="let policy of policyList">
                <div class="pbe-input-group pbe-input-group--policy-num">
                    <label class="pbe-label">Póliza</label>
                    <div class="pbe-input pbe-input--readonly pbe-input--multiline">
                        <span>{{ policy.number || '' }}</span>
                        <span class="pbe-field-sub">{{ policy.product || '' }}</span>
                    </div>
                </div>
                <div class="pbe-input-group pbe-input-group--bank-sel">
                    <label class="pbe-label">Cuenta bancaria</label>
                    <select *ngIf="policy.isEditable" class="pbe-select"
                            [attr.disabled]="(accountList.length === 0 || changingAccountId === policy.id) ? '' : null"
                            (change)="onChangeAccount($event, policy)">
                        <option value="{{ policy.bankAccount }}" selected>{{ policy.bankAccount }}</option>
                        <option *ngFor="let c of accountList" value="{{ c.itemName }}"
                                [hidden]="c.itemName === policy.bankAccount">{{ c.itemName }}</option>
                    </select>
                    <div *ngIf="!policy.isEditable" class="pbe-input pbe-input--readonly">{{ policy.bankAccount }}</div>
                </div>
                <div class="pbe-input-group pbe-input-group--periodicity">
                    <label class="pbe-label">Tipo de pago</label>
                    <div class="pbe-input pbe-input--readonly">{{ policy.periodicity }}</div>
                </div>
            </div>

        </div>
    </div>

    <div class="pbe-section"  [formGroup]="bankForm">
        <div class="pbe-section__heading">
            <h3 class="pbe-section__title">Cuentas</h3>
        </div>

        <div class="pbe-form-cuentas">

            <div>
                <button type="button" class="pbe-btn pbe-btn--primary" (click)="toggleBankForm()">
                    + Añadir cuenta
                </button>
            </div>

            <ng-container *ngIf="showBankForm">
                <div class="pbe-row pbe-row--bank">
                    <div class="pbe-input-group pbe-input-group--iban">
                        <label class="pbe-label">IBAN</label>
                        <input type="text" class="pbe-input" formControlName="bankIban" maxlength="4" (paste)="captureIban($event)">
                    </div>
                    <div class="pbe-input-group pbe-input-group--entidad">
                        <label class="pbe-label">Entidad</label>
                        <input type="text" class="pbe-input" formControlName="bankEntity" maxlength="4" (paste)="captureIban($event)">
                    </div>
                    <div class="pbe-input-group pbe-input-group--sucursal">
                        <label class="pbe-label">Sucursal</label>
                        <input type="text" class="pbe-input" formControlName="bankBranch" maxlength="4" (paste)="captureIban($event)">
                    </div>
                    <div class="pbe-input-group pbe-input-group--dc">
                        <label class="pbe-label">DC</label>
                        <input type="text" class="pbe-input" formControlName="bankDc" maxlength="2" (paste)="captureIban($event)">
                    </div>
                    <div class="pbe-input-group pbe-input-group--cuenta">
                        <label class="pbe-label">Cuenta</label>
                        <input type="text" class="pbe-input" formControlName="bankAccount" maxlength="10" (paste)="captureIban($event)">
                    </div>
                </div>

                <div class="pbe-row pbe-row--bank-holder">
                    <div class="pbe-input-group pbe-input-group--titular">
                        <label class="pbe-label">Titular de la cuenta</label>
                        <input type="text" class="pbe-input" formControlName="bankHolder" maxlength="160">
                    </div>
                    <div class="pbe-input-group pbe-input-group--tipo">
                        <label class="pbe-label">Tipo</label>
                        <input type="text" class="pbe-input" formControlName="bankHolderType" maxlength="10">
                    </div>
                    <div class="pbe-input-group pbe-input-group--holder-num">
                        <label class="pbe-label">Numero</label>
                        <input type="text" class="pbe-input" formControlName="bankHolderNumber" maxlength="20">
                    </div>
                </div>

                <div class="pbe-input-group">
                    <label class="pbe-label">Documento cuenta bancaria</label>

                    <label *ngIf="!bankDocumentFile" class="pbe-file-drop" for="bankDocumentFile"
                        [class.pbe-file-drop--active]="isDragOver"
                        (dragover)="onDragOver($event)"
                        (dragleave)="onDragLeave($event)"
                        (drop)="onDrop($event)">
                        <input type="file" id="bankDocumentFile" class="pbe-file-drop__input"
                            (change)="onBankDocumentSelected($event)" accept=".pdf,.jpg,.jpeg,.png">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" width="24" height="24">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke-linecap="round" stroke-linejoin="round"/>
                            <polyline points="17 8 12 3 7 8" stroke-linecap="round" stroke-linejoin="round"/>
                            <line x1="12" y1="3" x2="12" y2="15" stroke-linecap="round"/>
                        </svg>
                        <span>
                            Haga clic o arrastre para adjuntar un documento que acredite
                            la propiedad de la cuenta bancaria
                            <span class="pbe-required">(*) Obligatorio</span><br>
                        </span>
                    </label>

                    <div *ngIf="bankDocumentFile" class="pbe-file-attached">
                        <span class="pbe-file-attached__icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" width="20" height="20">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke-linecap="round" stroke-linejoin="round"/>
                                <polyline points="14 2 14 8 20 8" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        <div class="pbe-file-attached__info">
                            <span class="pbe-file-attached__name">{{ bankDocumentName }}</span>
                            <span class="pbe-file-attached__size">{{ bankDocumentFile.size / 1024 / 1024 | number: '.2' }} MB</span>
                        </div>
                        <button type="button" class="pbe-btn-trash" aria-label="Eliminar documento" (click)="onRemoveBankDocument()">
                            <svg style="pointer-events: none" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" width="16" height="16">
                                <polyline points="3 6 5 6 21 6" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M10 11v6M14 11v6" stroke-linecap="round"/>
                                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>

                <div class="pbe-footer__messages" *ngIf="messages && messages.length > 0">
                    <span *ngFor="let msg of messages">{{ msg }}</span>
                </div>

                <div class="pbe-footer">
                    <div class="pbe-footer__actions">
                        <button type="button" class="pbe-btn pbe-btn--cancel" (click)="onCancel()">
                            Cancelar
                        </button>
                        <app-spinner-button
                            [label]="getButtonLabel()"
                            [enabled]="submitEnabled()"
                            [running]="running"
                            (click)="onSave()">
                        </app-spinner-button>
                     </div>
                </div>
            </ng-container>

            <div class="pbe-accounts-grid">
                <div class="pbe-account-item" *ngFor="let account of accountList">
                    <label class="pbe-label">Cuenta bancaria</label>
                    <div class="pbe-account-box">
                        <span class="pbe-account-box__number">{{ account?.itemName }}</span>
                        <div class="inner-trash" (click)="onRemoveAccount($event, account)">
                            <button type="button" class="pbe-btn-trash" aria-label="Eliminar cuenta">
                                <svg style="pointer-events: none" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" width="16" height="16">
                                    <polyline points="3 6 5 6 21 6" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10 11v6M14 11v6" stroke-linecap="round"/>
                                    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                            <i class="spinner" style="display:none"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="pbe-empty-message" *ngIf="accountList.length === 0">
                <p>No hay cuenta referenciada, por favor añade una cuenta para poder continuar.</p>
            </div>

        </div>
    </div>

</div>
